import styled from "styled-components";

export const MapPickerOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    background-color: rgba(0,0,0,0.3);

    .mapWrap {
        position: relative;
        width: 90vw;
        max-width: 500px;
        .closeIcon {
            position: absolute;
            top: 50px;
            right: 10px;
            z-index: 1000;
            cursor: pointer;
            background: #fff;
            border-radius: 8px;
            padding: 4px;
            box-shadow: 0 2px 6px rgba(0,0,0,0.2);
        }
    }

    .mapSearch {
        position: relative;
        z-index: 1001;
        input {
            width: 100%;
            height: 38px;
            border: none;
            border-bottom: 2px solid #238cfa;
            padding: 0 10px;
            font-size: 14px;
            font-family: S-Core-Dream;
            box-sizing: border-box;
            outline: none;
        }
        .searchResultList {
            position: absolute;
            top: 38px;
            left: 0;
            width: 100%;
            max-height: 200px;
            overflow-y: auto;
            background: white;
            list-style: none;
            margin: 0;
            padding: 0;
            box-shadow: 0 2px 8px rgba(0,0,0,0.2);
            li {
                padding: 10px;
                font-size: 13px;
                font-family: S-Core-Dream;
                border-bottom: 1px solid #eee;
                cursor: pointer;
                text-align: left;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                &:hover {
                    background-color: #e8f4ff;
                }
            }
        }
    }

    #mapPicker {
        width: 100%;
        height: 90vw;
        max-height: 500px;
    }

    .gm-style-iw-c {
        background: none !important;
        box-shadow: none !important;
        padding: 0 !important;
        border-radius: 0 !important;
    }
    .gm-style-iw-d {
        overflow: hidden !important;
        padding: 0 !important;
    }
    .gm-style-iw-c button[aria-label="Close"],
    .gm-ui-hover-effect {
        display: none !important;
    }
    .gm-style-iw-tc {
        display: none !important;
    }

    .mapPickerSelectBtn {
        background: #238cfa;
        color: #fff;
        font-size: 13px;
        font-family: S-Core-Dream;
        font-weight: 600;
        padding: 7px 18px;
        border-radius: 20px;
        border: 2px solid #fff;
        cursor: pointer;
        white-space: nowrap;
        box-shadow: 0 2px 6px rgba(0,0,0,0.3);
    }

    .mapRegionToggle {
        position: absolute;
        top: 48px;
        left: 8px;
        z-index: 1002;
        display: flex;
        background: rgba(255,255,255,0.95);
        border-radius: 8px;
        box-shadow: 0 2px 6px rgba(0,0,0,0.25);
        overflow: hidden;

        button {
            border: none;
            background: transparent;
            display: flex;
            align-items: center;
            gap: 4px;
            padding: 6px 9px;
            font-size: 11px;
            font-family: S-Core-Dream;
            font-weight: 600;
            color: #6c757d;
            cursor: pointer;

            svg { display: block; }
            &.active { background: #238cfa; color: #fff; }
            &:not(:last-child) { border-right: 1px solid #e9ecef; }
        }
    }
`;
